module.exports = __webpack_public_path__ + "img/PT3400.a7fceb78.png";